/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { CustomResult } from '../models/custom-result';
import { CustomResultOfAuditVm } from '../models/custom-result-of-audit-vm';
import { CustomResultOfGetWhiteMessageCalculationsDto } from '../models/custom-result-of-get-white-message-calculations-dto';
import { CustomResultOfListOfGetWhiteMessagePrivateNumberForSendDto } from '../models/custom-result-of-list-of-get-white-message-private-number-for-send-dto';
import { CustomResultOfPaginatedListOfOrganWhiteMessagesWithPaginationDto } from '../models/custom-result-of-paginated-list-of-organ-white-messages-with-pagination-dto';
import { CustomResultOfPaginatedListOfPhonebooksByPrivateNumberDto } from '../models/custom-result-of-paginated-list-of-phonebooks-by-private-number-dto';
import { CustomResultOfPaginatedListOfWhiteMessagesWithPaginationDto } from '../models/custom-result-of-paginated-list-of-white-messages-with-pagination-dto';
import { CustomResultOfString } from '../models/custom-result-of-string';
import { CustomResultOfWhiteMessageByIdDto } from '../models/custom-result-of-white-message-by-id-dto';
import { whiteMessagesCreateGet } from '../fn/white-messages/white-messages-create-get';
import { WhiteMessagesCreateGet$Params } from '../fn/white-messages/white-messages-create-get';
import { whiteMessagesCreatePost } from '../fn/white-messages/white-messages-create-post';
import { WhiteMessagesCreatePost$Params } from '../fn/white-messages/white-messages-create-post';
import { whiteMessagesCreateWhiteSmsGet } from '../fn/white-messages/white-messages-create-white-sms-get';
import { WhiteMessagesCreateWhiteSmsGet$Params } from '../fn/white-messages/white-messages-create-white-sms-get';
import { whiteMessagesCreateWhiteSmsPost } from '../fn/white-messages/white-messages-create-white-sms-post';
import { WhiteMessagesCreateWhiteSmsPost$Params } from '../fn/white-messages/white-messages-create-white-sms-post';
import { whiteMessagesDelete } from '../fn/white-messages/white-messages-delete';
import { WhiteMessagesDelete$Params } from '../fn/white-messages/white-messages-delete';
import { whiteMessagesGetOrganizationWhiteMessagesWithPagination } from '../fn/white-messages/white-messages-get-organization-white-messages-with-pagination';
import { WhiteMessagesGetOrganizationWhiteMessagesWithPagination$Params } from '../fn/white-messages/white-messages-get-organization-white-messages-with-pagination';
import { whiteMessagesGetPhonebooksByPrivateNumber } from '../fn/white-messages/white-messages-get-phonebooks-by-private-number';
import { WhiteMessagesGetPhonebooksByPrivateNumber$Params } from '../fn/white-messages/white-messages-get-phonebooks-by-private-number';
import { whiteMessagesGetWhiteMessageCalculations } from '../fn/white-messages/white-messages-get-white-message-calculations';
import { WhiteMessagesGetWhiteMessageCalculations$Params } from '../fn/white-messages/white-messages-get-white-message-calculations';
import { whiteMessagesGetWhiteMessageCancelTextByPrivateNumberId } from '../fn/white-messages/white-messages-get-white-message-cancel-text-by-private-number-id';
import { WhiteMessagesGetWhiteMessageCancelTextByPrivateNumberId$Params } from '../fn/white-messages/white-messages-get-white-message-cancel-text-by-private-number-id';
import { whiteMessagesGetWhiteMessagePrivateNumberForSend } from '../fn/white-messages/white-messages-get-white-message-private-number-for-send';
import { WhiteMessagesGetWhiteMessagePrivateNumberForSend$Params } from '../fn/white-messages/white-messages-get-white-message-private-number-for-send';
import { whiteMessagesGetWhiteMessagesAudit } from '../fn/white-messages/white-messages-get-white-messages-audit';
import { WhiteMessagesGetWhiteMessagesAudit$Params } from '../fn/white-messages/white-messages-get-white-messages-audit';
import { whiteMessagesGetWhiteMessagesWithPagination } from '../fn/white-messages/white-messages-get-white-messages-with-pagination';
import { WhiteMessagesGetWhiteMessagesWithPagination$Params } from '../fn/white-messages/white-messages-get-white-messages-with-pagination';
import { whiteMessagesUpdateWhiteMessageGet } from '../fn/white-messages/white-messages-update-white-message-get';
import { WhiteMessagesUpdateWhiteMessageGet$Params } from '../fn/white-messages/white-messages-update-white-message-get';
import { whiteMessagesUpdateWhiteMessagePut } from '../fn/white-messages/white-messages-update-white-message-put';
import { WhiteMessagesUpdateWhiteMessagePut$Params } from '../fn/white-messages/white-messages-update-white-message-put';
import { whiteMessagesUpdateWhiteMessageStatusGet } from '../fn/white-messages/white-messages-update-white-message-status-get';
import { WhiteMessagesUpdateWhiteMessageStatusGet$Params } from '../fn/white-messages/white-messages-update-white-message-status-get';
import { whiteMessagesUpdateWhiteMessageStatusPut } from '../fn/white-messages/white-messages-update-white-message-status-put';
import { WhiteMessagesUpdateWhiteMessageStatusPut$Params } from '../fn/white-messages/white-messages-update-white-message-status-put';

@Injectable({ providedIn: 'root' })
export class WhiteMessagesService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `whiteMessagesCreateGet()` */
  static readonly WhiteMessagesCreateGetPath = '/WhiteMessages/Create';

  /**
   * For Authorize.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `whiteMessagesCreateGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  whiteMessagesCreateGet$Response(params?: WhiteMessagesCreateGet$Params, context?: HttpContext): Observable<StrictHttpResponse<Blob>> {
    return whiteMessagesCreateGet(this.http, this.rootUrl, params, context);
  }

  /**
   * For Authorize.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `whiteMessagesCreateGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  whiteMessagesCreateGet(params?: WhiteMessagesCreateGet$Params, context?: HttpContext): Observable<Blob> {
    return this.whiteMessagesCreateGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<Blob>): Blob => r.body)
    );
  }

  /** Path part for operation `whiteMessagesCreatePost()` */
  static readonly WhiteMessagesCreatePostPath = '/WhiteMessages/Create';

  /**
   * Create WhiteMessages.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `whiteMessagesCreatePost()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  whiteMessagesCreatePost$Response(params: WhiteMessagesCreatePost$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomResult>> {
    return whiteMessagesCreatePost(this.http, this.rootUrl, params, context);
  }

  /**
   * Create WhiteMessages.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `whiteMessagesCreatePost$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  whiteMessagesCreatePost(params: WhiteMessagesCreatePost$Params, context?: HttpContext): Observable<CustomResult> {
    return this.whiteMessagesCreatePost$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomResult>): CustomResult => r.body)
    );
  }

  /** Path part for operation `whiteMessagesCreateWhiteSmsGet()` */
  static readonly WhiteMessagesCreateWhiteSmsGetPath = '/WhiteMessages/CreateWhiteSms';

  /**
   * For Authorize.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `whiteMessagesCreateWhiteSmsGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  whiteMessagesCreateWhiteSmsGet$Response(params?: WhiteMessagesCreateWhiteSmsGet$Params, context?: HttpContext): Observable<StrictHttpResponse<Blob>> {
    return whiteMessagesCreateWhiteSmsGet(this.http, this.rootUrl, params, context);
  }

  /**
   * For Authorize.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `whiteMessagesCreateWhiteSmsGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  whiteMessagesCreateWhiteSmsGet(params?: WhiteMessagesCreateWhiteSmsGet$Params, context?: HttpContext): Observable<Blob> {
    return this.whiteMessagesCreateWhiteSmsGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<Blob>): Blob => r.body)
    );
  }

  /** Path part for operation `whiteMessagesCreateWhiteSmsPost()` */
  static readonly WhiteMessagesCreateWhiteSmsPostPath = '/WhiteMessages/CreateWhiteSms';

  /**
   * Create WhiteSms.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `whiteMessagesCreateWhiteSmsPost()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  whiteMessagesCreateWhiteSmsPost$Response(params: WhiteMessagesCreateWhiteSmsPost$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomResult>> {
    return whiteMessagesCreateWhiteSmsPost(this.http, this.rootUrl, params, context);
  }

  /**
   * Create WhiteSms.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `whiteMessagesCreateWhiteSmsPost$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  whiteMessagesCreateWhiteSmsPost(params: WhiteMessagesCreateWhiteSmsPost$Params, context?: HttpContext): Observable<CustomResult> {
    return this.whiteMessagesCreateWhiteSmsPost$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomResult>): CustomResult => r.body)
    );
  }

  /** Path part for operation `whiteMessagesUpdateWhiteMessageGet()` */
  static readonly WhiteMessagesUpdateWhiteMessageGetPath = '/WhiteMessages/UpdateWhiteMessage';

  /**
   * دریافت اطلاعات پیامک سفید.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `whiteMessagesUpdateWhiteMessageGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  whiteMessagesUpdateWhiteMessageGet$Response(params?: WhiteMessagesUpdateWhiteMessageGet$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomResultOfWhiteMessageByIdDto>> {
    return whiteMessagesUpdateWhiteMessageGet(this.http, this.rootUrl, params, context);
  }

  /**
   * دریافت اطلاعات پیامک سفید.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `whiteMessagesUpdateWhiteMessageGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  whiteMessagesUpdateWhiteMessageGet(params?: WhiteMessagesUpdateWhiteMessageGet$Params, context?: HttpContext): Observable<CustomResultOfWhiteMessageByIdDto> {
    return this.whiteMessagesUpdateWhiteMessageGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomResultOfWhiteMessageByIdDto>): CustomResultOfWhiteMessageByIdDto => r.body)
    );
  }

  /** Path part for operation `whiteMessagesUpdateWhiteMessagePut()` */
  static readonly WhiteMessagesUpdateWhiteMessagePutPath = '/WhiteMessages/UpdateWhiteMessage';

  /**
   * به روز رسانی مقادیر پیامک سفید توسط کاربر.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `whiteMessagesUpdateWhiteMessagePut()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  whiteMessagesUpdateWhiteMessagePut$Response(params: WhiteMessagesUpdateWhiteMessagePut$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomResult>> {
    return whiteMessagesUpdateWhiteMessagePut(this.http, this.rootUrl, params, context);
  }

  /**
   * به روز رسانی مقادیر پیامک سفید توسط کاربر.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `whiteMessagesUpdateWhiteMessagePut$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  whiteMessagesUpdateWhiteMessagePut(params: WhiteMessagesUpdateWhiteMessagePut$Params, context?: HttpContext): Observable<CustomResult> {
    return this.whiteMessagesUpdateWhiteMessagePut$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomResult>): CustomResult => r.body)
    );
  }

  /** Path part for operation `whiteMessagesGetWhiteMessagesWithPagination()` */
  static readonly WhiteMessagesGetWhiteMessagesWithPaginationPath = '/WhiteMessages/GetWhiteMessagesWithPagination';

  /**
   * لیست درخواست ها
   * لیست تمام پیامک سفید های ثبت شده تمام سازمان های زیر مجموعه و نوادگان برای تایید
   * فقط سوپر ادمین و کاربران پیشگام رایان میتونند درخواست های خودشون را ببینند و تایید کنند.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `whiteMessagesGetWhiteMessagesWithPagination()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  whiteMessagesGetWhiteMessagesWithPagination$Response(params: WhiteMessagesGetWhiteMessagesWithPagination$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomResultOfPaginatedListOfWhiteMessagesWithPaginationDto>> {
    return whiteMessagesGetWhiteMessagesWithPagination(this.http, this.rootUrl, params, context);
  }

  /**
   * لیست درخواست ها
   * لیست تمام پیامک سفید های ثبت شده تمام سازمان های زیر مجموعه و نوادگان برای تایید
   * فقط سوپر ادمین و کاربران پیشگام رایان میتونند درخواست های خودشون را ببینند و تایید کنند.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `whiteMessagesGetWhiteMessagesWithPagination$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  whiteMessagesGetWhiteMessagesWithPagination(params: WhiteMessagesGetWhiteMessagesWithPagination$Params, context?: HttpContext): Observable<CustomResultOfPaginatedListOfWhiteMessagesWithPaginationDto> {
    return this.whiteMessagesGetWhiteMessagesWithPagination$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomResultOfPaginatedListOfWhiteMessagesWithPaginationDto>): CustomResultOfPaginatedListOfWhiteMessagesWithPaginationDto => r.body)
    );
  }

  /** Path part for operation `whiteMessagesGetOrganizationWhiteMessagesWithPagination()` */
  static readonly WhiteMessagesGetOrganizationWhiteMessagesWithPaginationPath = '/WhiteMessages/GetOrganizationWhiteMessagesWithPagination';

  /**
   * لیست تمام پیامک سفید های ثبت شده سازمان جاری.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `whiteMessagesGetOrganizationWhiteMessagesWithPagination()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  whiteMessagesGetOrganizationWhiteMessagesWithPagination$Response(params: WhiteMessagesGetOrganizationWhiteMessagesWithPagination$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomResultOfPaginatedListOfOrganWhiteMessagesWithPaginationDto>> {
    return whiteMessagesGetOrganizationWhiteMessagesWithPagination(this.http, this.rootUrl, params, context);
  }

  /**
   * لیست تمام پیامک سفید های ثبت شده سازمان جاری.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `whiteMessagesGetOrganizationWhiteMessagesWithPagination$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  whiteMessagesGetOrganizationWhiteMessagesWithPagination(params: WhiteMessagesGetOrganizationWhiteMessagesWithPagination$Params, context?: HttpContext): Observable<CustomResultOfPaginatedListOfOrganWhiteMessagesWithPaginationDto> {
    return this.whiteMessagesGetOrganizationWhiteMessagesWithPagination$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomResultOfPaginatedListOfOrganWhiteMessagesWithPaginationDto>): CustomResultOfPaginatedListOfOrganWhiteMessagesWithPaginationDto => r.body)
    );
  }

  /** Path part for operation `whiteMessagesGetWhiteMessagePrivateNumberForSend()` */
  static readonly WhiteMessagesGetWhiteMessagePrivateNumberForSendPath = '/WhiteMessages/GetWhiteMessagePrivateNumberForSend';

  /**
   * لیست شماره خط اختصاصی همراه با آی دی برای ارسال پیامک سفید.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `whiteMessagesGetWhiteMessagePrivateNumberForSend()` instead.
   *
   * This method doesn't expect any request body.
   */
  whiteMessagesGetWhiteMessagePrivateNumberForSend$Response(params?: WhiteMessagesGetWhiteMessagePrivateNumberForSend$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomResultOfListOfGetWhiteMessagePrivateNumberForSendDto>> {
    return whiteMessagesGetWhiteMessagePrivateNumberForSend(this.http, this.rootUrl, params, context);
  }

  /**
   * لیست شماره خط اختصاصی همراه با آی دی برای ارسال پیامک سفید.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `whiteMessagesGetWhiteMessagePrivateNumberForSend$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  whiteMessagesGetWhiteMessagePrivateNumberForSend(params?: WhiteMessagesGetWhiteMessagePrivateNumberForSend$Params, context?: HttpContext): Observable<CustomResultOfListOfGetWhiteMessagePrivateNumberForSendDto> {
    return this.whiteMessagesGetWhiteMessagePrivateNumberForSend$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomResultOfListOfGetWhiteMessagePrivateNumberForSendDto>): CustomResultOfListOfGetWhiteMessagePrivateNumberForSendDto => r.body)
    );
  }

  /** Path part for operation `whiteMessagesGetPhonebooksByPrivateNumber()` */
  static readonly WhiteMessagesGetPhonebooksByPrivateNumberPath = '/WhiteMessages/GetPhonebooksByPrivateNumber';

  /**
   * لیست دفترچه های شماره اختصاصی انتخاب شده را با صفحه بندی و مرتب سازی بر می گرداند.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `whiteMessagesGetPhonebooksByPrivateNumber()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  whiteMessagesGetPhonebooksByPrivateNumber$Response(params: WhiteMessagesGetPhonebooksByPrivateNumber$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomResultOfPaginatedListOfPhonebooksByPrivateNumberDto>> {
    return whiteMessagesGetPhonebooksByPrivateNumber(this.http, this.rootUrl, params, context);
  }

  /**
   * لیست دفترچه های شماره اختصاصی انتخاب شده را با صفحه بندی و مرتب سازی بر می گرداند.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `whiteMessagesGetPhonebooksByPrivateNumber$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  whiteMessagesGetPhonebooksByPrivateNumber(params: WhiteMessagesGetPhonebooksByPrivateNumber$Params, context?: HttpContext): Observable<CustomResultOfPaginatedListOfPhonebooksByPrivateNumberDto> {
    return this.whiteMessagesGetPhonebooksByPrivateNumber$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomResultOfPaginatedListOfPhonebooksByPrivateNumberDto>): CustomResultOfPaginatedListOfPhonebooksByPrivateNumberDto => r.body)
    );
  }

  /** Path part for operation `whiteMessagesUpdateWhiteMessageStatusGet()` */
  static readonly WhiteMessagesUpdateWhiteMessageStatusGetPath = '/WhiteMessages/UpdateWhiteMessageStatus';

  /**
   * دریافت اطلاعات پیامک سفید.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `whiteMessagesUpdateWhiteMessageStatusGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  whiteMessagesUpdateWhiteMessageStatusGet$Response(params?: WhiteMessagesUpdateWhiteMessageStatusGet$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomResultOfWhiteMessageByIdDto>> {
    return whiteMessagesUpdateWhiteMessageStatusGet(this.http, this.rootUrl, params, context);
  }

  /**
   * دریافت اطلاعات پیامک سفید.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `whiteMessagesUpdateWhiteMessageStatusGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  whiteMessagesUpdateWhiteMessageStatusGet(params?: WhiteMessagesUpdateWhiteMessageStatusGet$Params, context?: HttpContext): Observable<CustomResultOfWhiteMessageByIdDto> {
    return this.whiteMessagesUpdateWhiteMessageStatusGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomResultOfWhiteMessageByIdDto>): CustomResultOfWhiteMessageByIdDto => r.body)
    );
  }

  /** Path part for operation `whiteMessagesUpdateWhiteMessageStatusPut()` */
  static readonly WhiteMessagesUpdateWhiteMessageStatusPutPath = '/WhiteMessages/UpdateWhiteMessageStatus';

  /**
   * به روز رسانی وضعیت و مقادیر پیامک سفید توسط مدیر.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `whiteMessagesUpdateWhiteMessageStatusPut()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  whiteMessagesUpdateWhiteMessageStatusPut$Response(params: WhiteMessagesUpdateWhiteMessageStatusPut$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomResult>> {
    return whiteMessagesUpdateWhiteMessageStatusPut(this.http, this.rootUrl, params, context);
  }

  /**
   * به روز رسانی وضعیت و مقادیر پیامک سفید توسط مدیر.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `whiteMessagesUpdateWhiteMessageStatusPut$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  whiteMessagesUpdateWhiteMessageStatusPut(params: WhiteMessagesUpdateWhiteMessageStatusPut$Params, context?: HttpContext): Observable<CustomResult> {
    return this.whiteMessagesUpdateWhiteMessageStatusPut$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomResult>): CustomResult => r.body)
    );
  }

  /** Path part for operation `whiteMessagesDelete()` */
  static readonly WhiteMessagesDeletePath = '/WhiteMessages';

  /**
   * Delete WhiteMessage.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `whiteMessagesDelete()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  whiteMessagesDelete$Response(params: WhiteMessagesDelete$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomResult>> {
    return whiteMessagesDelete(this.http, this.rootUrl, params, context);
  }

  /**
   * Delete WhiteMessage.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `whiteMessagesDelete$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  whiteMessagesDelete(params: WhiteMessagesDelete$Params, context?: HttpContext): Observable<CustomResult> {
    return this.whiteMessagesDelete$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomResult>): CustomResult => r.body)
    );
  }

  /** Path part for operation `whiteMessagesGetWhiteMessageCalculations()` */
  static readonly WhiteMessagesGetWhiteMessageCalculationsPath = '/WhiteMessages/GetWhiteMessageCalculations';

  /**
   * Get WhiteMessage Calculations.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `whiteMessagesGetWhiteMessageCalculations()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  whiteMessagesGetWhiteMessageCalculations$Response(params: WhiteMessagesGetWhiteMessageCalculations$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomResultOfGetWhiteMessageCalculationsDto>> {
    return whiteMessagesGetWhiteMessageCalculations(this.http, this.rootUrl, params, context);
  }

  /**
   * Get WhiteMessage Calculations.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `whiteMessagesGetWhiteMessageCalculations$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  whiteMessagesGetWhiteMessageCalculations(params: WhiteMessagesGetWhiteMessageCalculations$Params, context?: HttpContext): Observable<CustomResultOfGetWhiteMessageCalculationsDto> {
    return this.whiteMessagesGetWhiteMessageCalculations$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomResultOfGetWhiteMessageCalculationsDto>): CustomResultOfGetWhiteMessageCalculationsDto => r.body)
    );
  }

  /** Path part for operation `whiteMessagesGetWhiteMessageCancelTextByPrivateNumberId()` */
  static readonly WhiteMessagesGetWhiteMessageCancelTextByPrivateNumberIdPath = '/WhiteMessages/GetWhiteMessageCancelTextByPrivateNumberId';

  /**
   * دریافت متن لغو بر اساس شناسه خط اختصاصی.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `whiteMessagesGetWhiteMessageCancelTextByPrivateNumberId()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  whiteMessagesGetWhiteMessageCancelTextByPrivateNumberId$Response(params: WhiteMessagesGetWhiteMessageCancelTextByPrivateNumberId$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomResultOfString>> {
    return whiteMessagesGetWhiteMessageCancelTextByPrivateNumberId(this.http, this.rootUrl, params, context);
  }

  /**
   * دریافت متن لغو بر اساس شناسه خط اختصاصی.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `whiteMessagesGetWhiteMessageCancelTextByPrivateNumberId$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  whiteMessagesGetWhiteMessageCancelTextByPrivateNumberId(params: WhiteMessagesGetWhiteMessageCancelTextByPrivateNumberId$Params, context?: HttpContext): Observable<CustomResultOfString> {
    return this.whiteMessagesGetWhiteMessageCancelTextByPrivateNumberId$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomResultOfString>): CustomResultOfString => r.body)
    );
  }

  /** Path part for operation `whiteMessagesGetWhiteMessagesAudit()` */
  static readonly WhiteMessagesGetWhiteMessagesAuditPath = '/WhiteMessages/GetWhiteMessagesAudit';

  /**
   * Only for super admin, Get all audit logs.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `whiteMessagesGetWhiteMessagesAudit()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  whiteMessagesGetWhiteMessagesAudit$Response(params: WhiteMessagesGetWhiteMessagesAudit$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomResultOfAuditVm>> {
    return whiteMessagesGetWhiteMessagesAudit(this.http, this.rootUrl, params, context);
  }

  /**
   * Only for super admin, Get all audit logs.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `whiteMessagesGetWhiteMessagesAudit$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  whiteMessagesGetWhiteMessagesAudit(params: WhiteMessagesGetWhiteMessagesAudit$Params, context?: HttpContext): Observable<CustomResultOfAuditVm> {
    return this.whiteMessagesGetWhiteMessagesAudit$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomResultOfAuditVm>): CustomResultOfAuditVm => r.body)
    );
  }

}
